import { type ReactNode, useEffect, useRef } from "react";

import { useHistory, useLocation } from "react-router-dom";

import { useAuthContext } from "~/v2/providers/AuthProvider";

const fireLinkedInPixel = () => {
  const partnerId = (window as Window & { _linkedin_partner_id?: string })
    ._linkedin_partner_id;
  const element = document.createElement("img");
  element.alt = "";
  element.height = 1;
  element.width = 1;
  element.src = `https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`;
};

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { authStatus, cognitoUser } = useAuthContext();
  const history = useHistory();
  const location = useLocation();
  const prevPathname = useRef<string | null>(null);

  const isAuthenticated = cognitoUser?.attributes?.email_verified === true;

  useEffect(() => {
    if (authStatus !== "ready") {
      return;
    }

    if (!cognitoUser || !isAuthenticated) {
      window.sessionStorage?.setItem(
        "requested_path",
        location.pathname + location.search,
      );
      history.replace("/login");
    }
  }, [
    authStatus,
    cognitoUser,
    isAuthenticated,
    history.replace,
    location.pathname,
    location.search,
  ]);

  if (authStatus === "loading" || !isAuthenticated) {
    return null;
  }

  const { pathname } = location;
  if (pathname !== prevPathname.current) {
    fireLinkedInPixel();
    prevPathname.current = pathname;
  }

  return <>{children}</>;
};
